import gql from 'graphql-tag';

export default gql`
    mutation AddNewRole($input: AddNewRoleInput) {
        addNewRole(input: $input) {
            errors
        }
    }
`;
